<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="visitDate">Visit Date</label>
                    <wj-input-date id="visitDate" [(ngModel)]="target.visitDate" name="visitDate" [isRequired]="true"></wj-input-date>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="visitedByUserId">Visited By</label>
                    <wj-combo-box
                        id="visitedByUserId"
                        [(ngModel)]="target.visitedByUserId"
                        name="visitedByUserId"
                        (selectedIndexChanged)="onVisitedBySelected()"
                        [itemsSource]="memberMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="true"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="job">Job</label>
                    <wj-combo-box
                        id="job"
                        [(ngModel)]="target.job"
                        name="job"
                        (selectedIndexChanged)="onJobSelected()"
                        [itemsSource]="jobMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="true"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="notes">Notes</label>
                    <app-voice-text-field
                        [(ngModel)]="target.notes"
                        name="notes"
                        inputId="notes"
                        [rows]="3"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="observations">Observations</label>
                    <app-voice-text-field
                        [(ngModel)]="target.observations"
                        name="observations"
                        inputId="observations"
                        [rows]="4"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="safetyFeedback">Safety Feedback</label>
                    <app-voice-text-field
                        [(ngModel)]="target.safetyFeedback"
                        name="safetyFeedback"
                        inputId="safetyFeedback"
                        [rows]="3"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        @if (target.imageUrls && target.imageUrls.length > 0) {
            <div class="row">
                <label for="images-display">Images</label>
                @for (url of target.imageUrls; track url) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        @if (canEdit) {
                            <div class="close-x" (click)="removeExistingImage(url)">
                                <fa-icon [icon]="faX"></fa-icon>
                            </div>
                        }
                        <img style="width: 100%" [src]="'./Resources/Images/LeadershipTeamVisit/' + url + '?w=300'" />
                    </div>
                }
            </div>
        }
        @if (images && images.length > 0) {
            <div class="row">
                <label for="images-upload">Images To Upload</label>
                @for (image of images; track image) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <div class="close-x" (click)="removeImage(image)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <img style="width: 100%" [src]="image.url" />
                    </div>
                }
            </div>
        }
        @if (progress > 0 && progress < 100) {
            <div class="row">
                <div class="col-12">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{ 'width.%': progress }"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        @if (canEdit) {
            <button type="button" class="btn btn-secondary" style="margin-right: auto" (click)="fileInput.click()">Upload Image(s)</button>
            <input style="display: none" type="file" (change)="onFileChanged($event)" accept="image/*" #fileInput multiple />
        }
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
